// Central registry of event name constants

export const EVENT_NAMES = {
    ACCORDION_COLLAPSE: 'accordion_collapse',
    ACCORDION_EXPAND: 'accordion_expand',
    AUDIO_COMPLETED: 'audio_completed',
    AUDIO_PAUSED: 'audio_paused',
    AUDIO_PLAY: 'audio_play',
    BREADCRUMB: 'breadcrumb',
    BUTTON_CLICK: 'button_click',
    CALL_NUMBER: 'call_number',
    CLICK_LOGO: 'click_logo',
    DONATION_BEGIN: 'donation_begin',
    DONATION_SUBMIT: 'donation_submit',
    DONATION_SUBMIT_ERROR: 'donation_submit_error',
    DONATION_WIDGET: 'donation_widget',
    DOWNLOAD: 'download',
    EMAIL: 'email',
    FILTER_RESET: 'filter_reset',
    FILTER_SELECT: 'filter_select',
    FORM_BEGIN: 'form_begin',
    FORM_SUBMIT: 'form_submit',
    FORM_SUBMIT_ERROR: 'form_submit_error',
    META_NAVIGATION: 'meta_navigation',
    NAVIGATION: 'navigation',
    NEWSLETTER_SUBSCRIBE: 'newsletter_subscribe',
    OUTBOUND: 'outbound',
    PAGE_META: 'page_meta',
    PUBLICATION_ORDER: 'publication_order',
    SCROLL: 'scroll',
    SELECT_DONATION_AMOUNT: 'select_donation_amount',
    SELECT_DONATION_RHYTHM: 'select_donation_rhythm',
    SELECT_DONATION_TYPE: 'select_donation_type',
    SELECT_PAYMENT_METHOD: 'select_payment_method',
    SELECT_PRIORITY: 'select_priority',
    SELECT_SPONSORSHIP_TYPE: 'select_sponsorship_type',
    TEASERCARD_SELECT: 'teasercard_select',
    TOPIC_NAVIGATION: 'topic_navigation',
} as const;
